package com.qrkontaq.ui.admin

object AdminStringsEs : AdminStrings {
    override val tabDashboard = "Resumen"
    override val tabDashboardSub = "Qué pasa hoy en tu local"
    override val tabMenu = "Menú"
    override val tabMenuSub = "Categorías, platos, precios y agotados"
    override val tabStopList = "Agotados"
    override val tabStopListSub = "¿Se acabó un plato? Un toque"
    override val tabTables = "Mesas"
    override val tabTablesSub = "Llamadas de la sala y códigos QR para imprimir"
    override val tabStaff = "Equipo"
    override val tabStaffSub = "Invitaciones y roles del personal"
    override val tabSettings = "Ajustes"
    override val tabSettingsSub = "Marca, contactos, horario"
    override val tabSubscription = "Suscripción"
    override val tabSubscriptionSub = ""

    override val openSite = "Abrir sitio"
    override val logout = "Salir"
    override val viewSite = "ver el sitio"
    override val roleOwner = "Propietario"
    override val roleManager = "Gerente"
    override val roleWaiter = "Camarero"
    override val roleCook = "Cocinero"
    override val roleBartender = "Barman"
    override val roleStaff = "Empleado"

    override val interfaceLanguage = "Idioma del panel"
    override val pastDueBanner = "El período pagado ha terminado. Las funciones Pro seguirán activas unos días más."
    override val pay = "Pagar"
    override val statScans = "Escaneos QR"
    override val periodToday = "Hoy"
    override val periodWeek = "Semana"
    override val periodMonth = "Mes"
    override val periodYear = "Año"
    override val prevPeriod = "Período anterior"
    override val nextPeriod = "Período siguiente"
    override val statVisits = "Visitas"
    override val statRevenue = "Ingresos"
    override val statRating = "Valoración"
    override val statDishLikes = "Me gusta de platos"
    override val statCookedOrders = "Pedidos cocinados"
    override val statCookedDishes = "Platos cocinados"
    override val statDrinksMade = "Bebidas preparadas"
    override val statServedOrders = "Pedidos aceptados"
    override val statServedDishes = "Artículos aceptados"
    override val statTablesServed = "Mesas atendidas"
    override val myDishesCooked = "Qué has cocinado"
    override val myDrinksMade = "Bebidas que has preparado"
    override val myDishesServed = "Qué has aceptado"
    override val myTablesTitle = "Mesas"
    override val myTimelineTitle = "Cronología"
    override val myWorkEmpty = "Aún no hay datos en este período"
    override val scansByDay = "Evolución de escaneos"
    override fun maxBadge(value: String) = "máx. $value"
    override val peakHours = "Horas punta (escaneos)"
    override val scansByTable = "Escaneos por mesa"
    override val withoutTable = "sin mesa"
    override fun tableN(label: String) = "Mesa $label"
    override val topDishes = "Platos favoritos de los clientes"
    override val soldProducts = "Productos vendidos"
    override val dashEmptyTables = "Aún no hay escaneos"
    override val dashEmptyTablesHint = "Imprime los códigos QR de las mesas — aquí aparecerán las estadísticas por mesa"
    override val dashEmptySales = "Aún no hay ventas"
    override val dashEmptySalesHint = "En cuanto los clientes empiecen a pedir, aquí aparecerán los ingresos por plato"
    override val dashEmptyTop = "Aún no hay «me gusta»"
    override val dashEmptyTopHint = "Los clientes pueden dar «me gusta» a los platos de la carta — los favoritos aparecerán aquí"
    override val dashEmptyCallsHint = "No hubo llamadas en este período"
    override val dashEmptyPeakHint = "Los datos aparecerán tras los primeros escaneos QR"

    override val tabOrders = "Pedidos"
    override val tabOrdersSub = "Cocina y sala: estados de los platos en tiempo real"
    override val statusNew = "Nuevo"
    override val statusCooking = "Cocinando"
    override val statusReady = "Listo"
    override val statusServed = "Servido"
    override val takeOrder = "Empezar a cocinar"
    override val markReady = "Listo"
    override val markServed = "Servido"
    override val newOrderTitle = "Nuevo pedido"
    override val addOrderBtn = "Añadir pedido"
    override val addDishesHint = "Añade platos de la carta"
    override val totalLabel = "Total"
    override val markPaid = "Pagado"
    override val confirmPaid = "¿Marcar como pagado y liberar la mesa?"
    override val tableFree = "Libre"
    override val noActiveOrders = "No hay pedidos activos"
    override val ordersColumnEmpty = "Vacío"
    override fun orderTakenBy(name: String) = "Aceptado por $name"
    override val orderOtherWaiter = "Pedido de otro camarero"
    override val closeMixedTableHint = "En esta mesa hay un pedido de otro camarero — puede cerrarla un gerente"
    override val waitingWaiter = "Esperando al camarero"
    override val closeLabel = "Cerrar"
    override fun minutesShort(min: Long) = "$min min"
    override fun agoShort(min: Long) = when {
        min < 60 -> "$min min"
        min < 1440 -> "${min / 60} h"
        else -> "${min / 1440} d"
    }
    override val orderStepBack = "Retroceder"
    override val authCabinet = "El panel de tu local"
    override val authRegisterSub = "Crea una cuenta para entrar"
    override val authShopName = "Nombre del restaurante"
    override val authShopNamePh = "Cafetería «El Rincón»"
    override val authDomain = "Dominio"
    override val authDomainPh = "elrincon"
    override val authPassword = "Contraseña"
    override val authSignIn = "Entrar"
    override val authCreateAccount = "Crear cuenta"
    override val authCreateShop = "Crear el local"
    override val authWizardSub = "Último paso: crea tu establecimiento"
    override val authNoShop = "¿Aún no tienes local? Regístrate"
    override val authHaveAccount = "¿Ya tienes cuenta? Entrar"
    override val authNoAccount = "¿No tienes cuenta? Regístrate"
    override val authOr = "o"
    override val authBack = "Atrás"
    override val authContinueGoogle = "Continuar con Google"
    override val authContinueApple = "Continuar con Apple"
    override val authLoginFailed = "Email o contraseña incorrectos."
    override val authRegisterFailed = "No se pudo completar el registro. Revisa los datos."
    override val authErrEmailInvalid = "Introduce un email válido — por ejemplo, tu@ejemplo.com."
    override val authErrEmailTaken = "Este email ya está registrado. Prueba a entrar."
    override val authErrDomainTaken = "Esta dirección del sitio ya está ocupada — elige otra."
    override val authErrDomainRules =
        "Dirección del sitio: 3–30 caracteres, solo letras latinas, dígitos y guiones; debe empezar y terminar con letra o dígito."
    override val authPasswordHint = "Mínimo 6 caracteres"
    override val authErrPasswordRules =
        "La contraseña es demasiado corta: mínimo 6 caracteres."
    override val authErrInvalidCredentials = "Email o contraseña incorrectos."
    override val authErrOauthAccount = "Esta cuenta entra con Google/Apple — usa ese botón para iniciar sesión."
    override val authErrOauthEmailTaken = "Este email ya está registrado con contraseña: inicia sesión con tu email y contraseña."
    override val authErrDeactivated = "Esta cuenta está desactivada. Escribe a soporte."
    override val authErrDomainReserved = "Esta dirección está reservada por el sistema — elige otra."
    override val authErrNameRules = "Nombre del local: de 1 a 100 caracteres."
    override val brandTagline = "Tu propio sitio en 1 minuto — y a trabajar al instante"
    override val brandFeature1 = "Carta QR en varios idiomas"
    override val brandFeature2 = "Sala y cocina en tiempo real"
    override val brandFeature3 = "Estadísticas, agotados y equipo"
    override val brandFeature4 = "Pedidos, cuentas y pago"
    override val brandFeature6 = "Plan gratis, sin tarjeta"
    override val inviteWelcome = "Unirse al equipo"
    override val inviteAccepting = "Aceptando la invitación…"
    override fun inviteJoined(role: String) = "Te has unido como $role"
    override val inviteGoCabinet = "Ir al panel"
    override val inviteInvalid = "La invitación no es válida o ha caducado"
    override val inviteLoginHint = "Entra o regístrate para aceptar la invitación"
    override val hallCalls = "Llamadas de la sala"
    override val legendWaiter = "Camarero"
    override val legendBill = "Cuenta"
    override val asksBill = "pide la cuenta"
    override val callsWaiter = "llama al camarero"
    override val done = "Hecho"
    override val markedDone = "Marcado como hecho"
    override val callUpdateFailed = "No se pudo actualizar la llamada"
    override val layoutSaveFailed = "No se pudo guardar la disposición de las mesas"
    override val bootFailed = "No se pudo conectar con el servidor. Comprueba tu conexión e inténtalo de nuevo."
    override val bootRetry = "Reintentar"

    override fun inStop(count: Int) = "En agotados: $count"
    override fun totalDishes(count: Int) = "Platos en total: $count"
    override val searchDishPh = "Buscar plato…"
    override val nothingFound = "No se ha encontrado nada"
    override val tryAnotherQuery = "Prueba con otra búsqueda"
    override val outOfStock = "agotado"
    override fun backInMenu(name: String) = "«$name» vuelve a estar en la carta"
    override val putToStop = "Marcado como agotado"
    override val updateFailed = "No se pudo actualizar"

    override val addTableTitle = "Añadir mesa"
    override val tableLabelPh = "P. ej. 5 o Terraza 2"
    override val add = "Añadir"
    override val addTableFailed = "No se pudo añadir la mesa"
    override fun tablesCount(count: Int) = "Mesas ($count)"
    override val qrPdf = "QR en PDF"
    override val preparingPdf = "Preparando el PDF…"
    override fun deleteTable(label: String) = "Eliminar mesa $label"
    override fun deleteTableConfirm(label: String) = "¿Eliminar la mesa $label?"
    override val planHint = "Arrastra las mesas para colocarlas como en tu sala. La disposición se guarda en este navegador."
    override val noTablesTitle = "Aún no hay mesas"
    override val noTablesHint = "Añade mesas — y generaremos un PDF con códigos QR listo para imprimir"

    override val inviteTitle = "Invitar a un empleado"
    override val inviteHint = "Camarero — mesas y pedidos. Cocinero — pedidos (mesas solo lectura). Gerente — todo excepto la suscripción."
    override val createInvite = "Crear invitación"
    override val inviteCreated = "Invitación creada"
    override val inviteCreateFailed = "No se pudo crear la invitación"
    override val copy = "Copiar"
    override val copied = "Copiado"
    override fun teamCount(count: Int) = "Equipo ($count)"
    override val removeFromTeam = "Quitar del equipo"
    override val removeFromTeamConfirm = "¿Quitar del equipo?"
    override val activeInvites = "Invitaciones activas:"
    override fun validUntil(date: String) = "válida hasta $date"
    override val cancel = "Cancelar"
    override val teamMembersWord = "miembros"
    override fun teamMemberSince(date: String) = "en el equipo desde $date"
    override val permWaiter = "Mesas y pedidos"
    override val permCook = "Pedidos de cocina"
    override val permBartender = "Pedidos de barra"
    override val permManager = "Todo excepto la suscripción"
    override val barCategory = "Categoría de barra (bebidas)"
    override val barBadge = "Barra"

    override val currentState = "Estado actual"
    override fun activeUntil(date: String) = "Activa hasta $date"
    override val pastDueLong = "Pago vencido — las funciones Pro se pausarán pronto"
    override val badgeActive = "Activa"
    override val badgePastDue = "Vencida"
    override val plan1Month = "1 mes"
    override val plan3Months = "3 meses"
    override val plan12Months = "12 meses"
    override val bestValueBadge = "-17% · el más rentable"
    override val payMono = "Elegir"
    override val autoRenewLabel = "Renovación automática"
    override val autoRenewHint = "Tu tarjeta se guarda tras el pago y la suscripción se renueva automáticamente. Puedes desactivarlo cuando quieras."
    override val autoRenewActive = { mask: String? ->
        "Renovación automática activada" + (mask?.let { " · tarjeta •••• $it" } ?: "")
    }
    override val autoRenewDisable = "Desactivar"
    override val planActiveTitle = "Plan activado"
    override val nextChargeOn = { date: String, amount: String -> "Próximo cargo $date · $amount" }
    override val autoRenewOffNote = { date: String -> "Renovación automática desactivada — el acceso dura hasta $date" }
    override val cancelSubscription = "Cancelar suscripción"
    override val resumeAutoRenew = "Reanudar la renovación automática"
    override val subActiveOverline = "Suscripción activa"
    override val subEyebrow = "Planes"
    override val subChooseTitle = "Free o Pro"
    override val subChooseSub = "Menú, pedidos y mesas — gratis para siempre. Pro desbloquea los servicios para clientes y el equipo."
    override val subFeaturesCap = "Incluido en Pro"
    override val subFeatures = listOf(
        "Programa de fidelización con cashback",
        "Botón para llamar al camarero",
        "Cuenta de la mesa para clientes",
        "Menú en varios idiomas",
        "Secciones «Popular» y «El chef recomienda»",
        "Equipo e invitaciones de personal",
    )
    override val subCtaSubscribe = "Pasar a Pro"
    override val trustCancel = "Cancela cuando quieras"
    override val trustSecure = "Pago seguro"

    override val planFree = "Free"
    override val planPro = "Pro"
    override val planFreeSub = "menú sin límites"
    override val planCurrent = "Tu plan"
    override val planRecommended = "Recomendado"
    override val perMonth = "al mes"
    override val proLockTitle = "Disponible con Pro"
    override val proLockTeamBody = "Invita a camareros, cocineros y gerentes con el plan Pro. Los miembros actuales del equipo se quedan."
    override val proUpgradeCta = "Pasar a Pro"
    override val proSectionHint = "Disponible en el plan Pro — actívalo en la pestaña «Suscripción»."
    override val proLangHint = "En Free hay un idioma de menú activo — cámbialo cuando quieras. Pro desbloquea todos los idiomas."
    override val payHint = "Pago a través de la página segura de monobank. Tras el pago, la suscripción se renueva automáticamente."
    override val paymentHistory = "Historial de pagos"

    override val newCategory = "Nueva categoría"
    override val addCategory = "Añadir categoría"
    override val hiddenBadge = "oculta"
    override val showLabel = "Mostrar"
    override val hideLabel = "Ocultar"
    override val moreActions = "Más acciones"
    override val moveUp = "Subir"
    override val moveDown = "Bajar"
    override val deleteCategory = "Eliminar categoría"
    override fun deleteCategoryConfirm(name: String) = "¿Eliminar la categoría «$name» junto con sus platos?"
    override val addDishPlus = "＋ Añadir plato"
    override val copySuffix = " (copia)"
    override val duplicate = "Duplicar"
    override val dishDuplicated = "Plato duplicado"
    override val duplicateFailed = "No se pudo duplicar"
    override val edit = "Editar"
    override val delete = "Eliminar"
    override fun deleteDishConfirm(name: String) = "¿Eliminar «$name»?"
    override val dishDeleted = "Plato eliminado"
    override val deleteFailed = "No se pudo eliminar"
    override val dangerZoneTitle = "Zona de peligro"
    override val dangerZoneHint =
        "Eliminar el local es permanente: desaparecen el menú, las fotos, las mesas, los pedidos, el equipo, la fidelización y la dirección del sitio."
    override val deleteVenueButton = "Eliminar local"
    override val deleteVenueModalTitle = "¿Eliminar este local?"
    override val deleteVenueModalBody =
        "Esta acción no se puede deshacer. Se eliminarán para siempre el menú y las fotos, las mesas y los códigos QR, " +
            "los pedidos y las estadísticas, el equipo y las invitaciones, el programa de fidelización y la dirección del sitio."
    override fun deleteVenueConfirmLabel(name: String) = "Para confirmar, escribe el nombre «$name»"
    override val deleteVenueConfirmPlaceholder = "Nombre del local"
    override val deleteVenueConfirmCta = "Eliminar para siempre"
    override val deleteVenueSuccess = "Local eliminado"
    override val stopBadge = "agotado"
    override val descriptionLabel = "Descripción"
    override val descriptionPh = "P. ej.: Tomate, mozzarella, albahaca fresca"
    override val priceLabel = "Precio"
    override val weightLabel = "Peso/volumen"
    override val weightPh = "320 g"
    override val kcalLabel = "Kcal"
    override val tagsLabel = "Etiquetas"
    override val allergensLabel = "Alérgenos"
    override val tagVegan = "Vegano"
    override val tagSpicy = "Picante"
    override val tagNew = "Novedad"
    override val allergenGluten = "Gluten"
    override val allergenLactose = "Lactosa"
    override val allergenNuts = "Frutos secos"
    override val allergenEggs = "Huevos"
    override val allergenFish = "Pescado"
    override val allergenSoy = "Soja"
    override val chefRecommends = "El chef recomienda"
    override val uploadingEllipsis = "Subiendo…"
    override val addPhoto = "Añadir foto"
    override val replacePhoto = "Cambiar foto"
    override val photoUploadFailed = "No se pudo subir la foto"
    override val addDish = "Añadir plato"
    override val save = "Guardar"
    override val dishAdded = "Plato añadido"
    override val savedToast = "Guardado"
    override val saveFailed = "No se pudo guardar"
    override val menuStatCategories = "categorías"
    override val menuStatDishes = "platos"
    override val menuStatFeatured = "destacados"
    override val menuEmptyTitle = "Tu carta está vacía"
    override val menuEmptyHint = "Crea tu primera categoría — y empieza a añadir platos."
    override val categoryLabel = "Categoría"
    override val editCategory = "Editar categoría"
    override val editDish = "Editar plato"
    override val noCategory = "Sin categoría"

    override val sitePreviewTitle = "Así se verá el sitio"
    override val sitePreviewHint = "La vista previa se actualiza al instante — guarda para aplicarlo en el sitio."
    override val restaurantNamePh = "Nombre del local"
    override val brandTitle = "Marca"
    override val logoLabel = "Logo"
    override val coverLabel = "Portada"
    override val nameLabel = "Nombre"
    override val shortDescription = "Descripción corta"
    override val accentHint = "Color de acento — botones, precios y destacados en el sitio de tu local"
    override val customColorLabel = "O un color propio"
    override val contactsTitle = "Contactos"
    override val addressLabel = "Dirección"
    override val mapPickHint = "Mueve el mapa para que el marcador señale tu local"
    override val mapFindByAddress = "Buscar por dirección"
    override val mapUseLocation = "Mi ubicación"
    override val phoneLabel = "Teléfono"
    override val socialsHint = "Redes sociales — se muestran a los clientes en la sección «Sobre nosotros» del sitio"
    override val workingHoursTitle = "Horario"
    override val workingHoursHint = "Vacío = día de cierre. Formato 09:00 / 22:00; también se admite pasada la medianoche (18:00–02:00)."
    override val dayMon = "Lun"
    override val dayTue = "Mar"
    override val dayWed = "Mié"
    override val dayThu = "Jue"
    override val dayFri = "Vie"
    override val daySat = "Sáb"
    override val daySun = "Dom"
    override val dayOff = "cerrado"
    override val siteThemeTitle = "Tema del sitio"
    override val siteThemeHint = "Cómo ve la carta el cliente: clara, oscura o automática según los ajustes del móvil."
    override val themeAuto = "Auto (según el cliente)"
    override val themeLight = "Clara"
    override val themeDark = "Oscura"
    override val menuLookTitle = "Aspecto de la carta"
    override val categoryPhotosTitle = "Fotos en las categorías"
    override val categoryPhotosHint = "El chip de la categoría muestra la foto del primer plato; sin foto — solo texto"
    override val featureFirstTitle = "Primer plato como tarjeta grande"
    override val featureFirstHint = "El primer plato de la categoría lleva una foto a todo el ancho; desactivado — como los demás"
    override val showPopularTitle = "Sección «Populares»"
    override val showPopularHint = "Mostrar una selección de platos populares al inicio de la carta"
    override val showChefTitle = "Sección «El chef recomienda»"
    override val showChefHint = "Mostrar una selección de platos recomendados por el chef"
    override val showFiltersTitle = "Botón de filtros"
    override val showFiltersHint = "Mostrar el botón de filtros junto a las categorías de la carta"
    override val menuLanguagesTitle = "Idiomas de la carta"
    override val menuLanguagesHint = "El cliente podrá cambiar entre estos idiomas en el sitio. Rellena los nombres y descripciones en los idiomas elegidos."
    override val saveChanges = "Guardar cambios"
    override val savedCheck = "Guardado ✓"
    override val savedSiteUpdated = "Guardado — el sitio está actualizado"
    override val saveFailedCheckColor = "No se pudo guardar (revisa el color #RRGGBB)"
    override val upload = "Subir"
    override val replace = "Cambiar"

    override val currencyTitle = "Moneda"
    override val currencyHint = "Moneda de los precios de la carta y de los bonos de los clientes."
    override val guestServicesTitle = "Servicios en la mesa"
    override val guestServicesHint = "Lo que el cliente ve en la página de la mesa tras escanear el QR"
    override val guestCheckTitle = "Mostrar la cuenta al cliente"
    override val guestCheckHint = "El cliente ve su cuenta en tiempo real: artículos, cantidades y total"
    override val waiterCallTitle = "Llamada al camarero"
    override val waiterCallHint = "El cliente puede llamar al camarero o pedir la cuenta"
    override val loyaltyTitle = "Programa de fidelización"
    override val loyaltyEnableTitle = "Cashback para clientes"
    override val loyaltyEnableHint = "El cliente acumula bonos con cada cuenta y los canjea al pagar"
    override val loyaltyRateLabel = "Porcentaje de cashback de la cuenta (1–50)"
    override val loyaltyRateHint = "Este porcentaje del importe de la cuenta vuelve al cliente en bonos"
    override val loyaltyGuestTitle = "Bonos del cliente"
    override val loyaltyCandidatesTitle = "Escanearon esta mesa hace poco"
    override val loyaltyCodePh = "Código de 6 dígitos"
    override val loyaltyScanQr = "Escanear QR"
    override val loyaltyFindGuest = "Buscar cliente"
    override val loyaltyCodeNotFound = "Código no encontrado"
    override val loyaltyCodeExpired = "Código caducado — pide al cliente que muestre uno nuevo"
    override val loyaltyCheckFailed = "No se pudo comprobar el código"
    override val loyaltyBalanceLabel = "Saldo"
    override val loyaltyRedeemLabel = "Canjear bonos"
    override val loyaltyEarnedLabel = "Acumulado"
    override val loyaltyRedeemedLabel = "Canjeado"
    override val loyaltyNewBalanceLabel = "Nuevo saldo"
    override val loyaltyClear = "Limpiar"
    override val loyaltyCameraFailed = "Cámara no disponible — introduce el código a mano"
    override val loyaltyGuestAtTable = "Cliente en la mesa"
    override val loyaltyNewGuest = "Cliente nuevo"
    override val loyaltyVisitsSuffix = "visitas"
    override val loyaltyCallingWaiter = "Llama al camarero"
    override val loyaltyCallingBill = "Pide la cuenta"
}
